export function Kalos(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      {}
      <g fill="none" fillRule="evenodd">
        <path d="m12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035q-.016-.005-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427q-.004-.016-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093q.019.005.029-.008l.004-.014l-.034-.614q-.005-.018-.02-.022m-.715.002a.02.02 0 0 0-.027.006l-.006.014l-.034.614q.001.018.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
        <path
          fill="currentColor"
          d="M12 1a1 1 0 0 1 1 1v1.957q.048.525.109 1.049a1 1 0 0 1 .254 1.926l.063.414c.275 1.762.691 3.87 1.282 5.654H15a1 1 0 0 1 .464 1.886q.268.564.57 1.114H17a1 1 0 0 1 .23 1.974c.77 1.168 1.603 2.31 2.523 3.367A1 1 0 0 1 19 23h-4a1 1 0 0 1-.847-.468l-.061-.113a2.8 2.8 0 0 0-.522-.72C13.204 21.324 12.697 21 12 21s-1.204.324-1.57.699a3 3 0 0 0-.436.561l-.086.159A1 1 0 0 1 9 23H5a1 1 0 0 1-.751-1.66c.919-1.058 1.75-2.197 2.521-3.366A1 1 0 0 1 7 16h.966q.302-.55.57-1.114A1 1 0 0 1 9 13h.292c.525-1.585.913-3.428 1.185-5.055l.16-1.013a1 1 0 0 1 .254-1.926q.061-.525.11-1.05V2a1 1 0 0 1 1-1Zm2.88 17H9.12a36 36 0 0 1-2.04 3h1.35c.14-.207.329-.452.57-.699c.61-.625 1.603-1.301 3-1.301s2.39.676 3 1.301c.242.247.43.492.57.699h1.35a36 36 0 0 1-2.04-3m-1.557-3h-2.646l-.222.503l-.236.497h3.562l-.236-.497zM12 10.617a35 35 0 0 1-.442 1.795L11.39 13h1.222a33 33 0 0 1-.61-2.383Z"
        />
      </g>
    </svg>
  );
}
